import { List } from 'lucide-react';
import { CampaignLabel } from '@/code/frontend/components/campaign/CampaignLabel';
import { CommandItem } from '@/code/frontend/components/ui/command';

interface CmdKCampaignItemProps {
  id: string;
  name: string;
  ownerName?: string | null;
  onSelect: () => void;
}

/**
 * A campaign item in the CmdK dialog.
 */
export function CmdKCampaignItem({
  id,
  name,
  ownerName,
  onSelect,
}: CmdKCampaignItemProps) {
  return (
    <CommandItem
      value={`campaign-${id}`}
      onSelect={onSelect}
      className="flex items-center gap-3"
    >
      <List className="h-4 w-4 text-muted-foreground" />
      <span className="truncate">
        <CampaignLabel name={name} ownerName={ownerName} />
      </span>
    </CommandItem>
  );
}
